module.exports = __webpack_public_path__ + "static/media/Valley-day.0895b45d.svg";